import './Menu.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var content = '_1m01arl3-3-15-1';
export var group = '_1m01arl5-3-15-1';
export var groupContainer = '_1m01arl4-3-15-1';
export var item = _7a468({defaultClassName:'_1m01arl6-3-15-1',variantClassNames:{disabled:{true:'_1m01arl7-3-15-1',false:'_1m01arl8-3-15-1'}},defaultVariants:{disabled:false},compoundVariants:[]});
export var itemChildren = '_1m01arl9-3-15-1';
export var label = '_1m01arl2-3-15-1';
export var subChildren = '_1m01arla-3-15-1';
export var tooltip = '_1m01arl0-3-15-1';
export var tooltipWrapper = '_1m01arl1-3-15-1';